import { getAuthHeaders } from '~/services/api';

/**
 * The scoped office's headers. By default `getAuthHeaders` scopes a request to the store's selected office;
 * a parent that picks a child office inside the shift form (GOTU-14829) collects for THAT child without
 * switching offices, so every read and write here takes the office to scope to and sets `x-office` itself.
 */
export const scopedHeaders = async (officeId?: string | null): Promise<Record<string, string>> => {
  const headers = await getAuthHeaders();
  return officeId ? { ...headers, 'x-office': officeId } : headers;
};
